// Functionality for lazy load of videos

class lazyLoad {
  defaultOptions: LazyOptions = {
    rootMargin: '0px',
    root: null,
    threshold: 0,
    classDefault: '',
    classOnLoad: '',
    initMoment: 'ready',
  }
  options: LazyOptions
  videosAttr: string
  userOptions: LazyOptions | Record<string, unknown>
  videos: NodeListOf<Element> | never[] = []

  constructor(videosAttr: string, options = {}) {
    // Default options
    this.defaultOptions = {
      rootMargin: '0px',
      root: null,
      threshold: 0,
      classDefault: '',
      classOnLoad: '',
      initMoment: 'ready',
    }

    this.videosAttr = videosAttr

    // Set init options as default
    this.options = this.defaultOptions

    // Get user options
    this.userOptions = options

    // Override options with given
    this.options = Object.assign(this.options, this.userOptions)

    this.init()
  }

  init() {
    // Find all videos
    this.videos = document.querySelectorAll(this.videosAttr)
    // Check if there are any videos
    if (this.videos.length > 0) {
      // Check if functionality to cache videos using IndexDB has been activated from options
      // NOT SUPPORTED YET

      // Init intersection observer to handle change of src if video in viewport
      if ('IntersectionObserver' in window) {
        // Create options for observer
        const observerOptions = {
          root: this.options.root,
          rootMargin: this.options.rootMargin,
          threshold: this.options.threshold,
        }

        const lazyvideosObserver = new IntersectionObserver(
          (entries, observer) => {
            // Handle all entries (all videos in this case)
            entries.forEach((entry) => {

              // Check if video should be active
              if (entry.isIntersecting) {

                // Get video
                const video = entry.target
                // Check if is already loaded or is currently loading
                if (
                  video.getAttribute('data-lazy-video-loaded') != 'true' ||
                  video.getAttribute('data-lazy-video-loading') != 'true'
                ) {
                  // If is not loaded or loading, add attr that is loading now
                  video.setAttribute('data-lazy-video-loading', 'true')

                  // Add listener to load
                  video.addEventListener('load', () => {
                    // On load, add specified class
                    video.classList.add(this.options.classOnLoad)

                    // unobserve this video
                    lazyvideosObserver.unobserve(video)

                    // Remove attr that is loading
                    video.removeAttribute('data-lazy-video-loading')
                    // Add attr that is already loaded
                    video.setAttribute('data-lazy-video-loaded', 'true')
                  }) // Override src

                  const src = video.getAttribute('data-src')


                  // ;(video as HTMLVideoElement).src = src ? src : ''
                  video.src = src ? src : ''
                  video.play()
                }

                // Override src
              }
            })
          },
          observerOptions,
        )

        // Loop through all videos and observe them
        // Check if lazyLoad has been initialized on read or on load
        // If on ready, wait with observing for load
        if (this.options.initMoment === 'ready') {
          this.videos.forEach((lazyVideo) => {
            // Check if lazy load on this video is already initialized
            if (
              lazyVideo.getAttribute('data-lazy-video-already-init') !== 'true'
            ) {
              lazyVideo.setAttribute('data-lazy-video-already-init', 'true')

              // Add class specified in options to every video
              lazyVideo.classList.add(this.options.classDefault)

              lazyvideosObserver.observe(lazyVideo)
            }
          })
        } else if (this.options.initMoment === 'custom') {
          this.videos.forEach((lazyVideo) => {
            if (
              lazyVideo.getAttribute('data-lazy-video-already-init') !== 'true'
            ) {
              lazyVideo.setAttribute('data-lazy-video-already-init', 'true')

              // Add class specified in options to every video
              lazyVideo.classList.add(this.options.classDefault)
              lazyvideosObserver.observe(lazyVideo)
            }
          })
        } else {
          console.error(
            "initMoment for lazyLoad has not been found. Available options: 'ready' - (default), 'custom'. Current option: " +
            this.options.initMoment,
          )
        }
      }
    }
  }
}

export type LazyOptions = {
  rootMargin: string
  root: Element | null
  threshold: number
  classDefault: string
  classOnLoad: string
  initMoment: string
}

window.addEventListener('load', () => {
  new lazyLoad("[data-lazy-video='true']", {
    rootMargin: '200px',
    classDefault: 'lazy-video',
    classOnLoad: 'lazy-video--active',
  })
})

// Reinit lazy load on custom event

window.addEventListener('bw-lazy-reload', () => {
  new lazyLoad("[data-lazy-video='true']", {
    rootMargin: '200px',
    classDefault: 'lazy-video',
    classOnLoad: 'lazy-video--active',
  })
})
